<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }"
        >首页</el-breadcrumb-item
      >
      <el-breadcrumb-item>海外事务管理</el-breadcrumb-item>
      <el-breadcrumb-item>海外组委会申请信息</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <!-- 筛选 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="100px"
        ref="queryFormRef"
      >
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="查询码" prop="queryCode">
              <el-input
                v-model="queryForm.queryCode"
                placeholder="请输入查询码"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="审核状态" prop="state">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.state"
                clearable
              >
                <el-option label="待审核" :value="0"></el-option>
                <el-option label="审核通过" :value="1"></el-option>
                <el-option label="审核驳回" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button
            type="primary"
            style="width: 100%"
            @click="getDataList('search')"
            >查询</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button
            type="primary"
            plain
            style="width: 100%"
            @click="reset"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <!-- 申请信息列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="9">
          <span class="title_class">申请信息列表</span>
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="联系人姓名" prop="contactName"></el-table-column>
        <el-table-column label="联系人电话" prop="contactPhone"></el-table-column>
        <el-table-column label="邮箱" prop="registerEmail"></el-table-column>
        <el-table-column label="国家" prop="countryName"></el-table-column>
        <el-table-column label="州" prop="zstateName"></el-table-column>
        <el-table-column label="学校" prop="schoolName">
          <template slot-scope="scope">
            <el-tag size="mini" type="danger" v-if="!scope.row.schoolId && scope.row.schoolName">新增</el-tag> {{ scope.row.schoolName }}
          </template>
        </el-table-column>
        <el-table-column label="查询码" prop="queryCode"></el-table-column>
        <el-table-column label="身份" prop="identity" :formatter="identityFormat"></el-table-column>
        <el-table-column label="职务" prop="contactPosition"></el-table-column>
        <el-table-column label="审核状态" prop="state">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.state === 0" type="warning" size="mini">待审核</el-tag>
            <el-tag v-else-if="scope.row.state === 1" type="success" size="mini">审核通过</el-tag>
            <el-tag v-else-if="scope.row.state === 2" type="danger" size="mini">驳回</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="申请原因" prop="applyNote">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.applyNote || '-'"
              placement="top"
            >
              <span class="text-ellipsis">{{ scope.row.applyNote || '-' }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" prop="applyTime"></el-table-column>
        <el-table-column label="操作" width="100px" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleAudit(scope.row)"
              >审核</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <!-- 审核对话框 -->
    <el-dialog
      title="审核"
      :visible.sync="auditDialogVisible"
      width="50%"
      @close="auditDialogClose"
    >
      <el-form
        :model="auditForm"
        label-width="120px"
        ref="auditFormRef"
        :rules="auditRules"
        style="width: 100%"
      >
        <el-form-item label="审核状态" prop="state">
          <el-select
            v-model="auditForm.state"
            placeholder="请选择审核状态"
            style="width: 100%"
          >
            <el-option label="待审核" :value="0"></el-option>
            <el-option label="审核通过" :value="1"></el-option>
            <el-option label="审核驳回" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核原因" prop="reviewNote">
          <el-input
            type="textarea"
            v-model="auditForm.reviewNote"
            placeholder="请输入审核原因"
            :rows="4"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="auditDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAudit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getOverseasCommitteeApplyforList, auditOverseasCommitteeApplyfor } from '@/http/api'
export default {
  data () {
    return {
      queryForm: {
        queryCode: '',
        state: null,
        pageNum: 1,
        pageSize: 10
      },
      dataList: [],
      total: 0,
      auditDialogVisible: false, // 审核对话框显示状态
      auditForm: {
        state: null, // 审核状态：0待审核、1审核通过、2审核驳回
        reviewNote: '', // 审核原因
        id: null // 主键id
      },
      auditRules: {
        state: [{ required: true, message: '请选择审核状态', trigger: 'change' }],
        reviewNote: [{ required: true, message: '请输入审核原因', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.getDataList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    // 获取列表信息
    getDataList (getType) {
      if (getType === 'search') {
        this.queryForm.pageNum = 1
        this.queryForm.pageSize = 10
      }
      getOverseasCommitteeApplyforList(this.queryForm).then((res) => {
        console.log('getOverseasCommitteeApplyforList', res)
        this.dataList = res.data.list || []
        this.total = res.data.total || 0
      }).catch((err) => {
        console.log('err', err)
        this.$message.error('获取列表失败')
      })
    },
    // 重置搜索条件
    reset () {
      this.$refs.queryFormRef.resetFields()
      this.getDataList()
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getDataList()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getDataList()
    },
    // 单条审核
    handleAudit (row) {
      this.auditForm.id = row.id
      this.auditForm.state = row.state
      this.auditDialogVisible = true
    },
    // 提交审核
    submitAudit () {
      this.$refs.auditFormRef.validate(async valid => {
        if (!valid) return

        const params = {
          state: this.auditForm.state,
          reviewNote: this.auditForm.reviewNote,
          id: this.auditForm.id
        }

        auditOverseasCommitteeApplyfor(params).then((res) => {
          console.log('auditOverseasCommitteeApplyfor', res)
          this.$message.success('审核成功')
          this.auditDialogVisible = false
          this.getDataList()
        }).catch((err) => {
          console.log('审核失败', err)
          this.$message.error('审核失败')
        })
      })
    },
    // 关闭审核对话框
    auditDialogClose () {
      this.$refs.auditFormRef.resetFields()
      this.auditForm = {
        state: null,
        reviewNote: '',
        id: null
      }
    },
    identityFormat (data) {
      // 1选手 2学校组委会 3国家组委会 4教师
      const arr = ['', '选手', '学校组委会', '国家组委会', '教师']
      return data.identity ? arr[data.identity] : ''
    }
  }
}
</script>

<style lang="less" scoped>
.text-ellipsis {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}</style>
